const textEncoder = new TextEncoder()

// btoa / atob alone cannot handle multibyte characters correctly (Umlaute, emoji, etc.)
export function base64Encode(fieldValue: string): string {
    const utf8Bytes = textEncoder.encode(fieldValue)
    const base64String = btoa(String.fromCharCode(...utf8Bytes))

    return base64String.replace(/=+$/, "")
}
